import moment from 'moment'

export const formatDate = (date, format = 'MM/DD/YY') => moment.utc(date).format(format)

export const formatCurrency = (amount, digits = 2) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: digits
}).format(amount)

export const mapAttributes = (arr, attributes) => arr.map(item => ({ ...item, ...attributes }))

export const validateAmount = (value, max = value, min = 0) => {
  const pValue = parseFloat(value)
  const pMax = parseFloat(max)
  const pMin = parseFloat(min)

  return pValue < pMin ? pMin : pValue > pMax ? pMax : pValue
}

export const calcAmount = (acc, invoice) => acc + validateAmount(parseFloat(invoice.value), invoice.balance)

export const validateAmountFormat = (value, max = value, min = 0) => parseFloat(validateAmount(value, max, min)).toFixed(2)
export const toMoneyFormat = amount => parseFloat(amount).toFixed(2)

export const queryHasProducts = params => {
  const keys = Object.keys(params)
  return keys.includes('orderSerno') || keys.includes('cartId')
}

export const invoicesAmounts = invoices => {
  const data = invoices.reduce((acc, { invoiceNum, balance, value }) => {
    acc.invoices.push(invoiceNum)
    acc.amounts.push(value || balance)
    return acc
  }, { invoices: [], amounts: [] })

  return {
    invoiceNumbers: data.invoices.join(','),
    invoiceAmounts: data.amounts.join(',')
  }
}

export const totalAmount = ({ selectedItems, donations, productsTotal }) => {
  const selectedItemsTotal = selectedItems.map(({ data }) => data).reduce(calcAmount, 0.0)
  const donationsTotal = donations.reduce(calcAmount, 0.0)
  const total = selectedItemsTotal + donationsTotal + productsTotal
  return parseFloat(total.toFixed(2))
}

export const getMemberNumbersFromSelectedItems = selectedItems => {
  return selectedItems
    .map(({ data: { memberNumber } }) => memberNumber)
    .reduce((acc, value) => {
      if (!acc.includes(value)) acc.push(value)
      return acc
    }, [])
}

export const hasDuesSelected = selectedItems =>
  selectedItems
    .map(({ data: { productArea } }) => productArea)
    .includes('PGAMEM')

export const isDonationNan = (str) => {
  return /[a-zA-Z&=!@#$%^*()'+_;:,<>`~{}]/.test(str)
}
